import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import AnimatedLetters from "../AnimatedLetters/AnimatedLetters";
import "./Home.scss";

function Home() {
  // null  = loading
  // false = fetch failed / misconfigured
  // number = real persistent count
  const [visitCount, setVisitCount] = useState(null);
  const [letterClass, setLetterClass] = useState("text-animate");
  const hasFetched = useRef(false);

  const nameArray = ["S", "a", "m", "e", "e", "r", ","];
  const jobArray = [
    "A",
    "I",
    " ",
    "S",
    "y",
    "s",
    "t",
    "e",
    "m",
    "s",
    " ",
    "E",
    "n",
    "g",
    "i",
    "n",
    "e",
    "e",
    "r",
    ".",
  ];

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 4000);

    if (!hasFetched.current) {
      hasFetched.current = true;
      fetch("/api/visitor")
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (typeof data.count === "number") {
            setVisitCount(data.count);
          } else {
            console.error("visitor counter: unexpected response", data);
            setVisitCount(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching visit count:", error);
          setVisitCount(false);
        });
    }

  }, []);

  return (
    <>
      <div className="home-page">
        <span className="tags top-html">&lt;/html&gt;</span>
        <span className="tags top-tags">&lt;body&gt;</span>
        <div className="container ">
          <div className="text-zone">
            <h1>
              <span
                className={letterClass}
                onMouseEnter={(e) => e.target.classList.add("rubberBand")}
                onAnimationEnd={(e) => e.target.classList.remove("rubberBand")}
              >
                H
              </span>
              <span
                className={`${letterClass} _12`}
                onMouseEnter={(e) => e.target.classList.add("rubberBand")}
                onAnimationEnd={(e) => e.target.classList.remove("rubberBand")}
              >
                i,
              </span>
              <br />
              <span
                className={`${letterClass} _13`}
                onMouseEnter={(e) => e.target.classList.add("rubberBand")}
                onAnimationEnd={(e) => e.target.classList.remove("rubberBand")}
              >
                I
              </span>
              <span
                className={`${letterClass} _14`}
                onMouseEnter={(e) => e.target.classList.add("rubberBand")}
                onAnimationEnd={(e) => e.target.classList.remove("rubberBand")}
              >
                'm
              </span>
              <span className="hero-gap" aria-hidden="true"></span>
              <AnimatedLetters
                letterClass={letterClass}
                strArray={nameArray}
                idx={15}
              />
              <br />
              <span style={{ display: "block", whiteSpace: "nowrap" }}>
                <AnimatedLetters
                  letterClass={letterClass}
                  strArray={jobArray}
                  idx={22}
                />
              </span>
            </h1>
            <h2>
              AI Systems &amp; Backend Engineer | Distributed Systems | AI Infrastructure
            </h2>
            <Link to="/contact" className="flat-button">
              CONTACT ME!
            </Link>
          </div>
          <div className="visitor-counter">
            <span className="counter-label">You are visitor #</span>
            <span className="counter-number">
              {visitCount === null && "..."}
              {visitCount === false && "—"}
              {typeof visitCount === "number" && visitCount}
            </span>
          </div>
          
        </div>
        <span className="tags bottom-tags">
          &lt;/body&gt;
          <br />
          <span className="bottom-tag-html">&lt;/html&gt;</span>
        </span>
      </div>
    </>
  );
}

export default Home;